import React from 'react'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { QuickbetBadgeGreenStyled } from './QuickbetBadges.styles'

export const EarlyPayoutBadge = () => {
  return (
    <QuickbetBadgeGreenStyled>
      <Icon size='1rem' name='CustomEarlyPayout' />
      <span>Early Payout</span>
    </QuickbetBadgeGreenStyled>
  )
}

export const CashOutBadge = () => {
  return <QuickbetBadgeGreenStyled>Cash out</QuickbetBadgeGreenStyled>
}
